import React, { useEffect, useState } from "react";
import styles from "./Reupload.module.css";
import NewHeader from "../NavBar/newHeader";
import DocUpload from "../../component/DocumentPurposeUpload/DocUpload";
import { useNavigate } from "react-router";
import { useMyContext } from "../../myContext";

const ReuploadDoc = () => {
  const { listReuploadDocuments, setListReuploadDocuments, remitterStatus } =
    useMyContext();
  const [reUploadDocumentsRequired, setReUploadDocumentsRequired] = useState(
    []
  );
  // const history = useNavigate();

  // On mount, restore listReuploadDocuments from sessionStorage if context is empty
  useEffect(() => {
    // const nextStep = sessionStorage.getItem("nextStep");
    // if(nextStep !== "Reupload_Doc" || listReuploadDocuments.length == 0){
    //     history('/transaction-detail')
    // }

    // Restore from sessionStorage on refresh
    const storedDocs = sessionStorage.getItem("listReuploadDocuments");
    if (storedDocs && listReuploadDocuments.length === 0) {
      setListReuploadDocuments(JSON.parse(storedDocs));
    }
  }, [listReuploadDocuments.length, setListReuploadDocuments]);

  // Save to sessionStorage whenever listReuploadDocuments changes
  useEffect(() => {
    if (listReuploadDocuments.length !== 0) {
      sessionStorage.setItem(
        "listReuploadDocuments",
        JSON.stringify(listReuploadDocuments)
      );
    }
  }, [listReuploadDocuments]);

  useEffect(() => {
    if (listReuploadDocuments.length !== 0) {
      let newListOfDoc = [];
      // Check if remitter has Aadhaar number
      const hasAdhaarNo = remitterStatus?.adhaarNo || remitterStatus?.aadhaarNo;

      listReuploadDocuments.forEach((doc) => {
        if (doc.doctype === "PASSPORT") {
          if (hasAdhaarNo) {
            // If Aadhaar exists, only add REMITTER_AADHAAR and STUDENT_PASSPORT
            newListOfDoc.push({
              doctype: "REMITTER_AADHAAR",
              side: "front",
              reason: doc.reason,
              docReasonCode: doc.docReasonCode,
            });
            newListOfDoc.push({
              doctype: "REMITTER_AADHAAR",
              side: "back",
              reason: doc.reason,
              docReasonCode: doc.docReasonCode,
            });
          } else {
            // If no Aadhaar, add REMITTER_PASSPORT as before
            newListOfDoc.push({
              doctype: "REMITTER_PASSPORT",
              side: "front",
              reason: doc.reason,
              docReasonCode: doc.docReasonCode,
            });
            newListOfDoc.push({
              doctype: "REMITTER_PASSPORT",
              side: "back",
              reason: doc.reason,
              docReasonCode: doc.docReasonCode,
            });
          }
          // Always add STUDENT_PASSPORT - Front and Back
          newListOfDoc.push({
            doctype: "STUDENT_PASSPORT",
            side: "front",
            reason: doc.reason,
            docReasonCode: doc.docReasonCode,
          });
          newListOfDoc.push({
            doctype: "STUDENT_PASSPORT",
            side: "back",
            reason: doc.reason,
            docReasonCode: doc.docReasonCode,
          });
        } else if (doc.doctype === "PAN") {
          // REMITTER_PAN - Front only
          newListOfDoc.push({
            doctype: "REMITTER_PAN",
            side: "front",
            reason: doc.reason,
            docReasonCode: doc.docReasonCode,
          });
          // STUDENT_PAN - Front only
          newListOfDoc.push({
            doctype: "STUDENT_PAN",
            side: "front",
            reason: doc.reason,
            docReasonCode: doc.docReasonCode,
          });
        } else {
          newListOfDoc.push(doc);
        }
      });
      setReUploadDocumentsRequired(newListOfDoc);
    }
  }, [listReuploadDocuments, remitterStatus]);

  return (
    <>
      <NewHeader message="" linkName="Logout" show={true} />
      <div className={`container ${styles.mainContainer}`}>
        <DocUpload
          reUploadDocumentsRequired={reUploadDocumentsRequired}
          isReupload={true}
        />
      </div>
    </>
  );
};

export default ReuploadDoc;
